import createTableStore from "ds/components/Table/store/useTableStore";

import { READY_TO_MIGRATE_TABLE_STORAGE_KEY } from "../constants";
import { READY_TO_MIGRATE_TABLE_COLUMNS_CONFIG } from "./constants";

const useOpenTofuMigrationReadyToMigrateTableStore = createTableStore({
  storageKey: READY_TO_MIGRATE_TABLE_STORAGE_KEY,
  config: READY_TO_MIGRATE_TABLE_COLUMNS_CONFIG,
});

export default useOpenTofuMigrationReadyToMigrateTableStore;
